import { render, staticRenderFns } from "./MailBoxModule.vue?vue&type=template&id=0134165c&"
import script from "./MailBoxModule.vue?vue&type=script&lang=js&"
export * from "./MailBoxModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports